export default "__VITE_ASSET__Rew6agjI__"